module.exports = __webpack_public_path__ + "static/media/whatIsMatGif.3fcf89d5.gif";